import styled from 'styled-components';

interface PlayOverlayProps {
  $isPlaying?: boolean;
  $showOnHover?: boolean;
  $alwaysShow?: boolean;
}

export const PlayOverlay = styled.div<PlayOverlayProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ $isPlaying, $alwaysShow }) => 
    ($isPlaying || $alwaysShow) ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0)'};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $isPlaying, $alwaysShow }) => ($isPlaying || $alwaysShow) ? 1 : 0};
  transition: opacity 0.3s ease, background 0.3s ease;
  pointer-events: ${({ $showOnHover, $isPlaying }) => 
    ($showOnHover && !$isPlaying) ? 'none' : 'auto'};
`;

export const PlayIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    transition: none;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
  }
  
  svg {
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
    fill: white;
  }
`;

// 호버 효과를 적용할 컨테이너를 위한 mixin
export const hoverPlayOverlay = `
  &:hover .play-overlay {
    opacity: 1;
    background: rgba(0, 0, 0, 0.4);
  }
`;